export { ChatAlt as default } from './ChatAlt';
